<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="container-fluid">
       
            <!-- <h4>Care Context Consultation</h4> -->
           
            <div class="row mb-3" *ngIf="!isDemoGraphic">
                <div class="col-2"><label class="control-label">ABHA Address: </label></div>
                <div class="col-6">
                    <input type="text" autocomplete="off" maxlength="20" [(ngModel)]="abhaNumber"
                    class="form-control form-control-sm"  [readonly]="true">
                    
                </div>
                <!-- <div class="col-2 ml-0" *ngIf="!isDemoGraphic">
                    <button class="btn btn-sm btn-success" type="submit" value="submit" (click)="existhealthID()"
                    id="ver"  [disabled]="true">Verify</button>
                </div> -->
                <!-- <div class="col-2" *ngIf="modesData.length==0">
                    <button class="btn btn-sm btn-success" type="submit" value="submit" (click)="getModes()"
                    id="calBack">Retry</button>
                </div> -->
           </div>
          
           
         
    </div>
</div>